import { render, staticRenderFns } from "./editpressure.vue?vue&type=template&id=b3981b52&"
import script from "./editpressure.vue?vue&type=script&lang=ts&"
export * from "./editpressure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editpressure.vue"
export default component.exports